// extracted by mini-css-extract-plugin
module.exports = {"formInputWrapper":"FormInput_formInputWrapper__g6Vrf","inputBox":"FormInput_inputBox__Jm7z_","errorMessage":"FormInput_errorMessage__T6X4s"};